// extracted by mini-css-extract-plugin
export default {"eventWrapperButton":"options_eventWrapperButton__LigPJ"};